import { Anchor, Flex } from '@mantine/core';
import * as React from 'react';

import { IMedia } from 'entities/MediaModel/types';

import ImageWithSkeleton from '../ImageWithSkeleton';
import Text from '../Text';

type IconWithTextProps = {
  text: string;
  url: string;
  icon: IMedia;
};

const IconWithText: React.FC<IconWithTextProps> = ({ text, url, icon }) => {
  return (
    <Anchor href={url} target="_blank" size="xs" fw={600} c="gray.6">
      <Flex gap="xs" align="center">
        <span style={{ flexShrink: 0 }}>
          <ImageWithSkeleton urlImage={icon.url} height="20px" maxHeightImage="20px" width="20px" />
        </span>
        <Text size="xs" fw={600} c="gray.6" style={{ minWidth: 0, wordBreak: 'break-word' }}>
          {text}
        </Text>
      </Flex>
    </Anchor>
  );
};

export default IconWithText;
